import { render, staticRenderFns } from "./footer-card.vue?vue&type=template&id=0632918b&scoped=true&"
import script from "./footer-card.vue?vue&type=script&lang=js&"
export * from "./footer-card.vue?vue&type=script&lang=js&"
import style0 from "./footer-card.vue?vue&type=style&index=0&id=0632918b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0632918b",
  null
  
)

export default component.exports